import { useState } from "react";
import { toast } from "sonner";
import { Check, Copy } from "lucide-react";

export const CodeBlock = ({ title, code, testid }) => {
  const [ok, setOk] = useState(false);
  const copy = () => navigator.clipboard.writeText(code).then(() => { setOk(true); setTimeout(() => setOk(false), 1500); })
    .catch(() => toast.message("Select the code and copy it manually"));
  return (
    <div className="border border-white/10 bg-[#030505]" data-testid={testid}>
      <div className="flex items-center justify-between px-3 py-2 border-b border-white/10">
        <span className="label-xs">{title}</span>
        <button onClick={copy} className="flex items-center gap-1 font-mono text-[10px] text-white/50 hover:text-brand transition-colors" data-testid={`${testid}-copy`}>
          {ok ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />} {ok ? "COPIED" : "COPY"}
        </button>
      </div>
      <pre className="p-3 text-[11px] leading-relaxed text-white/75 overflow-x-auto whitespace-pre">{code}</pre>
    </div>
  );
};
